<template>

<app-icon name="share" class="share" v-tooltip="'Share this ' + type" v-on:click.native="onClick" />	

</template>

<script>

export default {
	
	props: ['type', 'identity'],

	methods: {

		onClick: function() {

			this.$pubsub.$emit('modal.open', {
				name: 'share',
				type: this.type,
				identity: this.identity
			})

		}

	}
	
}

</script>

<style scoped>

.share {
	width: 40px;
	height: 40px;
	border-radius: 4px;
	background-color: var(--color-blue-light);
	text-align: center;
	line-height: 40px;
	color: #fff;
	font-size: 16px;
	cursor: pointer;
}

.is-desktop .share:hover {
	background-color: var(--color-blue-dark);
}

</style>